export default __webpack_public_path__ + "static/media/discord.40bf9c7e.svg";